<template>
  <section class="city-cost-review-wrap">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="Refresh"
      @search="onHandleSearch"
    >
      <template v-slot:right>
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport || !tableData.length"
          >导出</el-button
        >
        <el-button
          type="info"
          :disabled="!selectIds.length || disabledAudit"
          @click="onBatchAudit"
          >批量审核</el-button
        >
        <el-button
          type="info"
          :disabled="!selectIds.length || disabledKou"
          @click="onBatchDeduct"
          v-if="is_deduct"
          >批量扣款</el-button
        >
        <el-button
          @click="onHandleSummaryExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledSummaryExport || !tableData.length"
          >回款导出</el-button
        >
      </template>
    </Filtersearch>
    <div class="totalWrap" v-if="formData.logistic_business_id">
      <span class="mr10 showText"
        >装卸费预扣: {{ totalData.handling_cost || "" }}元 已扣{{
          totalData.real_handling_cost || ""
        }}元
      </span>
      <span class="mr10 showText"
        >场地费预扣: {{ totalData.site_cost || "" }}元 已扣{{
          totalData.real_site_cost || ""
        }}元
      </span>
      <span class="mr10 showText"
        >合车费预扣: {{ totalData.merge_fare || "" }}元 已扣{{
          totalData.real_merge_fare || ""
        }}元
      </span>
      <span class="mr10 showText"
        >用板费预扣: {{ totalData.plank_fee || "" }}元 已扣{{
          totalData.real_plank_fee || ""
        }}元
      </span>
      <span class="mr10 showText textRed"
        >待扣款城市仓：{{totalData.no_deduct_logistics_num}}个 未扣款金额：{{totalData.no_deduct_total}}元（{{totalData.no_deduct_min_time}}）
      </span>
    </div>
    <!-- 列表 start -->
    <section class="content-wrap">
      <table-list
        ref="table"
        v-loading="loadingData"
        :tableData="tableData"
        :is_deduct="is_deduct"
        @submit-form="submitForm"
        @onHandleEdit="onHandleEdit"
        @postAjaxLogisticsBasicFeeSettlementAudit="
          postAjaxLogisticsBasicFeeSettlementAudit
        "
        @postAjaxLogisticsBasicFeeSettlementDeduct="
          postAjaxLogisticsBasicFeeSettlementDeduct
        "
        @getSelectId="getSelectId"
        @changeModel="changeModel"
      ></table-list>
    </section>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 编辑 start -->
    <edit-config-dialog
      ref="editConfig"
      @submit-form="submitForm"
    ></edit-config-dialog>
    <!-- 编辑 end -->

    <!-- 修改车型 start -->
    <modify-vehicle-model ref="vehicleModelRef" @submit-form="submitForm" />
    <!-- 修改车型 end -->
  </section>
</template>
<script>
import editConfigDialog from "./modules/editConfig/index";
import TableList from "./modules/table-list/index.vue";
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import {
  CAR_CATEGORY_ENUM,
  IS_COMBINED_CAR,
  DEDUCTION_ENUM,
  EXAMINE_ENUM,
} from "./utils/enum/index";
import {
  postLogisticsBasicFeeSettlementList,
  postLogisticsBasicFeeSettlementAudit,
  postLogisticsBasicFeeSettlementDeduct,
  postLogisticsBasicFeeSettlementTotal,
} from "@/api/general/cost.js";
import {
  postLogisticsBasicFeeSettlementExport,
  postLogisticsBasicCostSummaryExport,
} from "@/api/export/center.js";
import { formatDate } from "@/utils//tools/date.js";
import modifyVehicleModel from "../modules/modify-vehicle-model";
import { postFleetCarVehicleModelMap } from "@/api/general/cost.js";

export default {
  name: "city-cost-review",
  components: { editConfigDialog, TableList, Filtersearch, modifyVehicleModel },
  data() {
    return {
      CAR_CATEGORY_ENUM,
      totalData: {}, // 总计数据
      IS_COMBINED_CAR,
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "logisticsList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "城市仓",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "logistics_id",
          placeholder: "请选择城市仓",
          label: "name",
          value: "id",
          selectoptionname: "cityList",
          selectoption: [],
        },
        {
          type: "select",
          name: "车型",
          clearable: true,
          model: "vehicle_model_name",
          placeholder: "车型",
          selectoptionname: "promotion_tag_list",
          label: "label",
          value: "value",
          selectoption: [],
        },
        {
          type: "select",
          name: "是否合车",
          clearable: true,
          model: "is_merge",
          placeholder: "是否合车",
          label: "label",
          value: "value",
          selectoption: IS_COMBINED_CAR,
        },
        {
          type: "input",
          name: "车牌(车头)",
          clearable: true,
          model: "front_license_plates_no",
          placeholder: "车牌(车头)",
        },
        {
          type: "select",
          name: "车类别",
          clearable: true,
          model: "vehicle_model_type_name",
          placeholder: "车类别",
          label: "label",
          value: "value",
          selectoption: CAR_CATEGORY_ENUM,
        },
        {
          type: "daterange",
          name: "发车日期",
          clearable: true,
          model: "time",
          startmodel: "start_date",
          endmodel: "end_date",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
        {
          type: "select",
          name: "是否平台调车",
          clearable: true,
          model: "is_platform_dispatch",
          placeholder: "是否平台调车",
          label: "label",
          value: "value",
          selectoption: IS_COMBINED_CAR,
        },
        {
          type: "select",
          name: "是否自装卸",
          clearable: true,
          model: "is_platform_fleet",
          placeholder: "是否自装卸",
          label: "label",
          value: "value",
          selectoption: IS_COMBINED_CAR,
        },
        {
          type: "select",
          name: "扣款状态",
          clearable: true,
          model: "is_deduct",
          placeholder: "扣款状态",
          label: "label",
          value: "value",
          selectoption: DEDUCTION_ENUM,
        },
        {
          type: "select",
          name: "审核状态",
          clearable: true,
          model: "is_audit",
          placeholder: "审核状态",
          label: "label",
          value: "value",
          selectoption: EXAMINE_ENUM,
        },
      ],
      loadingCityStore: false, // 城市仓加载loading
      cityStoreList: [],
      total: 0,
      loadingData: false,
      formData: {
        logistic_business_id: "",
        time: [
          formatDate(new Date().getTime() - 3600 * 1000 * 24),
          formatDate(),
        ],
        start_date: formatDate(new Date().getTime() - 3600 * 1000 * 24),
        end_date: formatDate(),
        logistics_id: [],
        vehicle_model_name: "",
        front_license_plates_no: "",
        is_merge: "",
        vehicle_model_type_name: "",
        is_platform_dispatch: "",
        is_platform_fleet: "",
        is_audit: "",
        is_deduct: "",
        page: 1,
        pageSize: 50,
      },
      formDataClone: {}, // 复制数据，用于初始化
      tableData: [], //列表数据
      logisticsList: [], // 集配中心列表
      cityList: [], // 城市仓列表
      selectIds: [], // 批量操作
      disabledExport: false,
      disabledSummaryExport: false, // 回款导出
      is_deduct: false,
      disabledAudit: false,
      disabledKou: false,
    };
  },
  created() {
    this.formDataClone = cloneDeep(this.formData);
    this.initData();
  },
  methods: {
    // 获取车型下拉
    async postAjaxFleetCarVehicleModelMap() {
      try {
        const res = await postFleetCarVehicleModelMap({
          is_all: 1,
        });
        console.log(res, "res=");
        this.typeList = res.data || [];

        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "promotion_tag_list"
          ) {
            el.selectoption = [...res.data];
          }
        });
      } catch (error) {
        console.log(error, "postFleetCarVehicleModelMap");
      }
    },
    // 修改车型
    changeModel(row) {
      this.$refs.vehicleModelRef.onInitData(row, 1);
    },
    // 成本汇总
    async postAjaxLogisticsBasicFeeSettlementTotal() {
      try {
        const res = await postLogisticsBasicFeeSettlementTotal({
          logistic_business_id: this.formData.logistic_business_id,
          start_date: this.formData.start_date,
          end_date: this.formData.end_date,
        });
        this.totalData = res.data;
      } catch (error) {
        console.log(error, "postLogisticsBasicFeeSettlementTotal");
      }
    },
    // 选中id 赋值
    getSelectId(e, e1, e2) {
      this.selectIds = e;
      this.disabledAudit = e1;
      this.disabledKou = e2;
      console.log(e, this.selectIds, "e1211");
    },
    // 批量审核
    onBatchAudit() {
      this.$confirm("确定批量审核么？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          this.postAjaxLogisticsBasicFeeSettlementAudit(
            this.selectIds,
            "batch"
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消批量审核",
          });
        });
    },
    // 批量扣款
    onBatchDeduct() {
      this.$confirm("确定批量扣款么？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          this.postAjaxLogisticsBasicFeeSettlementDeduct(
            this.selectIds,
            "batch"
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消批量扣款",
          });
        });
    },
    // 审核
    async postAjaxLogisticsBasicFeeSettlementAudit(ids, type) {
      try {
        const res = await postLogisticsBasicFeeSettlementAudit({
          logistics_fee_ids: ids,
        });
        this.$message({
          type: "success",
          message: "审核成功",
        });
        this.postAjaxLogisticsBasicFeeSettlementList();
        this.postAjaxLogisticsBasicFeeSettlementTotal();
        if (type == "batch") {
          this.$refs.table.clearSelect();
        }
      } catch (error) {
        console.log(error, "postLogisticsBasicFeeSettlementAudit");
      }
    },
    // 批量扣款
    async postAjaxLogisticsBasicFeeSettlementDeduct(ids, type) {
      try {
        const res = await postLogisticsBasicFeeSettlementDeduct({
          logistics_fee_ids: ids,
        });
        console.log(res, "res==");
    
 this.$message({
          type: "success",
          message:res.data.msg,
        });
      
       
        if (type == "batch") {
          this.$refs.table.clearSelect();
        }
        this.postAjaxLogisticsBasicFeeSettlementList();
        this.postAjaxLogisticsBasicFeeSettlementTotal();
      } catch (error) {
        console.log(error, "postLogisticsBasicFeeSettlementDeduct");
      }
    },
    // 获取城市仓列表
    async citylist() {
      try {
        const res = await this.$api.Followup.logisticsselect({
          name: "",
          page: 1,
          pageSize: 1000,
        });
        console.log(res, "res");
        this.cityList = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "cityList"
          ) {
            el.selectoption = [
              { id: "", name: "全部" },
              ...res.data,
            ];
          }
        });
      } catch (error) {
        console.log(error, "logisticsList");
      }
    },
    /**
     * 获取集配中心列表
     */
    async getAjaxLogisticsList() {
      try {
        const { data } = await this.$api.general.businessList({
          is_online: 1, // 启用中
        });
        this.logisticsList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "logisticsList"
          ) {
            el.selectoption = [{ area_code: "", name: "全部" }, ...data];
          }
        });
        console.log("ajax getAjaxLogisticsList", data);
      } catch (err) {
        console.log("ajax getAjaxLogisticsList err", err);
      }
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.postAjaxLogisticsBasicFeeSettlementList();
      this.postAjaxLogisticsBasicFeeSettlementTotal();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.postAjaxLogisticsBasicFeeSettlementList();
      this.postAjaxLogisticsBasicFeeSettlementTotal();
    },
    /**
     * 查询
     */
    onHandleSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.postAjaxLogisticsBasicFeeSettlementList();
      console.log(this.formData, " this.formData==");
      if (this.formData.logistic_business_id) {
        this.postAjaxLogisticsBasicFeeSettlementTotal();
      }
    },
    /**
     * 初始化数据
     */
    initData() {
      this.getAjaxLogisticsList();
      this.citylist();
      this.postAjaxFleetCarVehicleModelMap();
      this.postAjaxLogisticsBasicFeeSettlementList();
      if (this.formData.logistic_business_id) {
        this.postAjaxLogisticsBasicFeeSettlementTotal();
      }
    },
    /**
     * 列表数据
     */
    async postAjaxLogisticsBasicFeeSettlementList() {
      this.loadingData = true;
      try {
        const res = await postLogisticsBasicFeeSettlementList(this.formData);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.is_deduct = res.data.is_deduct;
      } catch (error) {
        console.log(error, "postLogisticsBasicFeeSettlementList");
      } finally {
        this.loadingData = false;
      }
    },
    /**
     * 重置数据
     */
    Refresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.postAjaxLogisticsBasicFeeSettlementList();
      this.postAjaxLogisticsBasicFeeSettlementTotal();
    },
    /**
     * 编辑
     */
    onHandleEdit(e) {
      this.$refs.editConfig.initData(e);
    },
    /**
     * 刷新列表
     */
    submitForm() {
      // this.formData.page = 1;
      this.postAjaxLogisticsBasicFeeSettlementList();
      this.postAjaxLogisticsBasicFeeSettlementTotal();
    },
    /**
     * 回款导出逻辑
     */
    async onHandleSummaryExport() {
      this.disabledSummaryExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await postLogisticsBasicCostSummaryExport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax postLogisticsBasicCostSummaryExport err", err);
        this.disabledSummaryExport = false;
      }
    },
    /**
     * 导出逻辑
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await postLogisticsBasicFeeSettlementExport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax postLogisticsBasicFeeSettlementExport err", err);
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
      this.disabledSummaryExport = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.city-cost-review-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .textRed {
  color: red;
}
  .form {
    padding: 13px 15px;
  }
  .content-wrap {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .totalWrap {
    margin-top: 10px;
    background: #ffffff;
    padding: 12px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;

    .showText {
      font-size: 16px;
    }
  }
}
</style>
